import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import React, { useContext } from 'react';
import moment from 'moment';

const TabletAppField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.tabletAppAssignedDate
		? `${moment(latestSoftwareUpdateData.tabletAppAssignedDate).format('MM/DD/YYYY h:mm:ss A')} ${
				latestSoftwareUpdateData.lastTabletAppVersionName
		  }`
		: undefined;

	return <FullInfoField label="tabletAppLabel" value={inputValue} />;
};

export default TabletAppField;
